import React from 'react';
import EditGameCategoryState from './editGameCategoryState/editGameCategoryState';
import ControlPanel from './components/ControlPanel/ControlPanel';
import ModalWindows from './components/ModalWindows/ModalWindows';
import Forms from './components/Forms/Forms';

const EditGameCategoryPage: React.FC = () => {
	return (
		<EditGameCategoryState>
			<ControlPanel />
			<Forms />
			<ModalWindows />
		</EditGameCategoryState>
	);
};

export default EditGameCategoryPage;
